/**
 * An AMD wrapper around chronology.js for loaders (like DOJO) that don't
 * support shims
 */

define(['text!/bower_components/chronology/chronology.js'], function(script){
	(new Function(script))();
	// eslint-disable-next-line no-undef
	return Chronology;
});

